import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { first, mergeMap, Observable } from 'rxjs';

/**
 * Interceptor to add the B2C token to the request
 * @param req - The request to add the token to
 * @param next - The next handler in the chain
 * @returns The modified request
 */
export function tokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const oidcSecurityService = inject(OidcSecurityService);

    return oidcSecurityService.getAccessToken('azureB2c').pipe(
        first(),
        mergeMap((accessToken) => {
            const authReq = accessToken
                ? req.clone({
                      setHeaders: { Authorization: `Bearer ${accessToken}` },
                  })
                : req;
            return next(authReq);
        }),
    );
}

/**
 * Interceptor to add the admin panel (azureAd) token to the request
 * @param req - The request to add the token to
 * @param next - The next handler in the chain
 * @returns The modified request
 */
export function adminTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const oidcSecurityService = inject(OidcSecurityService);

    return oidcSecurityService.getIdToken('azureAd').pipe(
        first(),
        mergeMap((accessToken) => {
            const authReq =
                !!accessToken && req.url.includes('/v1/admin/')
                    ? req.clone({
                          setHeaders: { Authorization: `Bearer ${accessToken}` },
                      })
                    : req;
            return next(authReq);
        }),
    );
}
